import { useQuery } from "react-query";
import { TotalsSuccessResponse } from "../../dashboard/models/TotalsSuccessResponse";
import { ReportingParameters } from "../models/reporting-parameters";
import { reportingHttp } from "./reports-http";

const cacheKeys = {
  reporting: "reporting",
};

export const useGetReportingData = (
  data: ReportingParameters,
  enabled: boolean,
  apiUrlKey?: string
) => {
  return useQuery<TotalsSuccessResponse, any>(
    [cacheKeys.reporting, enabled, data],
    () => reportingHttp.getReportingData(data, apiUrlKey),
    { refetchOnWindowFocus: false, enabled }
  );
};
